<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <el-tabs v-model="tabActive">
            <el-tab-pane name="first">
              <div slot="label">
                退款成功记录
                <span class="badge success">{{ financeStat.tkCgCount }}</span>
              </div>
              <RefundList2Success v-if="tabActive=='first'"></RefundList2Success>
            </el-tab-pane>
            <el-tab-pane name="second">
              <div slot="label">
                退款失败记录
                <span class="badge danger">{{ financeStat.tkSbCount }}</span>
              </div>
              <RefundList2Fail v-if="tabActive=='second'"></RefundList2Fail>
            </el-tab-pane>
            <el-tab-pane name="third">
              <div slot="label">
                拒绝退款记录
                <span class="badge">{{ financeStat.jjtkCount }}</span>
              </div>
              <RefundList2Reject v-if="tabActive=='third'"></RefundList2Reject>
            </el-tab-pane>
          </el-tabs>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import RefundList2Success from "./RefundList2_Success.vue"
import RefundList2Fail from "./RefundList2_Fail.vue"
import RefundList2Reject from "./RefundList2_Reject.vue"

export default {
  components: { PageHeader, RefundList2Success, RefundList2Fail, RefundList2Reject },
  data() {
    return {
      headLinks: [{ path: "", title: "已处理退款记录" }],
      tabActive: "first",
    }
  },
  computed: {
    financeStat() {
      return this.$store.state.app.financeStat
    },
  },

  mounted() {},

  methods: {
    /* tabClick(tab) {
      if (tab.name == "first") {
        this.loadData()
      } else if (tab.name == "second") {
        this.loadData2()
      }
    }, */
  },
}
</script>

<style lang="scss" scoped></style>
